export const CELL_COUNT = 6